angular.module('avant.interceptors', []);
require('./authenticationFailureInterceptor.coffee');
require('./logoutRedirectInterceptor.coffee');
require('./serverErrorInterceptor.coffee');
require('./tokenAuthInterceptor.coffee');
